export enum DeclineReasonType {
    CreditHistory = 0,
    Collateral = 1,
    Other = 2,
    BackgroundIssue = 3,
    UnableToVerifyIdentity = 4,
}
